document.addEventListener('DOMContentLoaded', () => {
    const blocksScroll = document.querySelectorAll('.js-scroll-params');
    if(blocksScroll){
        blocksScroll.forEach((item) => {
            new SimpleBar(item, {
                autoHide: false,
            })
        })
    }
})
